import { PiEyeglassesDuotone } from 'react-icons/pi';

import { Translate } from '@spazious/dollhouse-i18n';
import { useStore } from '@spazious/dollhouse-store';
import { ViewModeEnum } from '@spazious/dollhouse-types';
import { ButtonProps, Stack, StackProps, Typography } from '@spazious/dollhouse-uikit';

import { useDeviceInfo } from '../../hooks/index.js';
import { Features } from '../Features/index.js';
import { ToggleButtonLabel } from '../ToggleButtonLabel/index.js';
import { ToolModeButtonGroup } from '../ToolModeButtonGroup/index.js';

export interface ToolControlsProps extends StackProps {}

export const ToolControls: React.FC<ToolControlsProps> = (props) => {
  const set = useStore(({ set }) => set);
  const view = useStore(({ view }) => view);
  const isMobile = useDeviceInfo((state) => state.isMobile);
  const buttonSize: ButtonProps['size'] = isMobile ? 'small' : 'medium';

  return (
    <Stack {...props}>
      <Features features="tool.view">
        <ToggleButtonLabel
          actived={view === ViewModeEnum.Outlines}
          label={
            <Typography size="small" variant="label">
              <Translate>View</Translate>
            </Typography>
          }
          size={buttonSize}
          onClick={() => {
            set(({ view }) => ({
              view: view === ViewModeEnum.Outlines ? ViewModeEnum.Normal : ViewModeEnum.Outlines,
            }));
          }}
        >
          <PiEyeglassesDuotone />
        </ToggleButtonLabel>
      </Features>
      <ToolModeButtonGroup />
    </Stack>
  );
};
